import { BOJE_IGRACA, IMENA_IGRACA } from '../igra/prikaz'
import { NIVOI } from '../igra/mreza'

export interface AlatkeOpts {
  igrac: number
  nivo: number
  onIgrac(i: number): void
  onNivo(n: number): void
  onOcisti(): void
  onUkloni(): void
}

export interface Alatke {
  setIgrac(i: number): void
  setNivo(n: number): void
  setTablu(redovi: { ime: string; boja: string; kula: number; veza: number; lanac: string }[]): void
  setNagovestaj(html: string): void
  setUkloniMoguce(moze: boolean): void
}

export function buildAlatke(opts: AlatkeOpts): Alatke {
  const root = document.getElementById('ui')!
  let igrac = opts.igrac
  let nivo = opts.nivo

  const alatke = document.createElement('div')
  alatke.className = 'panel'
  alatke.id = 'alatke'
  alatke.innerHTML = `
    <div class="grupa">
      <span class="nat">Igrač</span>
      <div class="dugmici">
        ${BOJE_IGRACA.map(
          (b, i) => `
          <button class="tocka" data-igrac="${i}" title="${IMENA_IGRACA[i]} — taster ${i + 1}">
            <i style="background:${b}"></i>
          </button>`,
        ).join('')}
      </div>
    </div>

    <div class="crta"></div>

    <div class="grupa">
      <span class="nat">Kula</span>
      <div class="dugmici">
        ${NIVOI.map(
          (n, i) => `
          <button class="stepen" data-nivo="${i}" title="domet ${n.domet}, taster ${'ZXC'[i]}">
            <b>${n.ime}</b><small>${n.domet}</small>
          </button>`,
        ).join('')}
      </div>
    </div>

    <div class="crta"></div>

    <div class="grupa">
      <button class="act" id="ukloni" disabled>Ukloni</button>
      <button class="act" id="ocisti">Očisti sve</button>
    </div>
  `

  const tabla = document.createElement('div')
  tabla.className = 'panel'
  tabla.id = 'tabla'
  tabla.innerHTML = '<h2>Mreža</h2><div id="tabla-telo"></div>'

  const nagovestaj = document.createElement('div')
  nagovestaj.id = 'nagovestaj'

  root.append(alatke, tabla, nagovestaj)

  const telo = tabla.querySelector<HTMLDivElement>('#tabla-telo')!
  const dugmeUkloni = alatke.querySelector<HTMLButtonElement>('#ukloni')!

  function osvezi(): void {
    for (const b of alatke.querySelectorAll<HTMLButtonElement>('button[data-igrac]')) {
      b.dataset.on = Number(b.dataset.igrac) === igrac ? '1' : '0'
    }
    for (const b of alatke.querySelectorAll<HTMLButtonElement>('button[data-nivo]')) {
      b.dataset.on = Number(b.dataset.nivo) === nivo ? '1' : '0'
    }
    alatke.style.setProperty('--boja-igraca', BOJE_IGRACA[igrac])
  }

  for (const b of alatke.querySelectorAll<HTMLButtonElement>('button[data-igrac]')) {
    b.addEventListener('click', () => {
      igrac = Number(b.dataset.igrac)
      osvezi()
      opts.onIgrac(igrac)
    })
  }
  for (const b of alatke.querySelectorAll<HTMLButtonElement>('button[data-nivo]')) {
    b.addEventListener('click', () => {
      nivo = Number(b.dataset.nivo)
      osvezi()
      opts.onNivo(nivo)
    })
  }
  alatke.querySelector('#ocisti')!.addEventListener('click', () => opts.onOcisti())
  dugmeUkloni.addEventListener('click', () => opts.onUkloni())

  window.addEventListener('keydown', (e) => {
    if (e.target instanceof HTMLInputElement) return
    const i = ['Digit1', 'Digit2', 'Digit3', 'Digit4'].indexOf(e.code)
    if (i >= 0) {
      igrac = i
      osvezi()
      opts.onIgrac(igrac)
    }
    const n = ['KeyZ', 'KeyX', 'KeyC'].indexOf(e.code)
    if (n >= 0) {
      nivo = n
      osvezi()
      opts.onNivo(nivo)
    }
    if (e.code === 'Delete' || e.code === 'Backspace') {
      e.preventDefault()
      opts.onUkloni()
    }
  })

  osvezi()

  return {
    setIgrac(i) {
      igrac = i
      osvezi()
    },
    setNivo(n) {
      nivo = n
      osvezi()
    },
    setTablu(redovi) {
      telo.innerHTML = redovi
        .map(
          (r) => `
        <div class="red">
          <i style="background:${r.boja}"></i>
          <span class="ime">${r.ime}</span>
          <span class="br">${r.kula}</span>
          <span class="br">${r.veza}</span>
          <span class="lanac">${r.lanac}</span>
        </div>`,
        )
        .join('')
    },
    setNagovestaj(html) {
      nagovestaj.innerHTML = html
      nagovestaj.dataset.ima = html ? '1' : '0'
    },
    setUkloniMoguce(moze) {
      dugmeUkloni.disabled = !moze
    },
  }
}
